// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ComePulireIlCottoRouteImport } from './routes/come-pulire-il-cotto'
import { Route as ContattaciRouteImport } from './routes/contattaci'
import { Route as PuliziaLavaggioCottoRouteImport } from './routes/pulizia-lavaggio-cotto'
import { Route as PuliziaTrattamentoGresRouteImport } from './routes/pulizia-trattamento-gres'
import { Route as ServiziRouteImport } from './routes/servizi'
import { Route as TrattamentoCottoEsternoRouteImport } from './routes/trattamento-cotto-esterno'
import { Route as TrattamentoMarmoPietreGranigliaRouteImport } from './routes/trattamento-marmo-pietre-graniglia'
import { Route as TrattamentoPavimentiCottoBergamoRouteImport } from './routes/trattamento-pavimenti-cotto-bergamo'
import { Route as TrattamentoPavimentiCottoBresciaRouteImport } from './routes/trattamento-pavimenti-cotto-brescia'
import { Route as TrattamentoPavimentiCottoMilanoRouteImport } from './routes/trattamento-pavimenti-cotto-milano'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ComePulireIlCottoRoute = ComePulireIlCottoRouteImport.update({
            id: '/come-pulire-il-cotto',path: '/come-pulire-il-cotto',getParentRoute: () => rootRouteImport
          })
const ContattaciRoute = ContattaciRouteImport.update({
            id: '/contattaci',path: '/contattaci',getParentRoute: () => rootRouteImport
          })
const PuliziaLavaggioCottoRoute = PuliziaLavaggioCottoRouteImport.update({
            id: '/pulizia-lavaggio-cotto',path: '/pulizia-lavaggio-cotto',getParentRoute: () => rootRouteImport
          })
const PuliziaTrattamentoGresRoute = PuliziaTrattamentoGresRouteImport.update({
            id: '/pulizia-trattamento-gres',path: '/pulizia-trattamento-gres',getParentRoute: () => rootRouteImport
          })
const ServiziRoute = ServiziRouteImport.update({
            id: '/servizi',path: '/servizi',getParentRoute: () => rootRouteImport
          })
const TrattamentoCottoEsternoRoute = TrattamentoCottoEsternoRouteImport.update({
            id: '/trattamento-cotto-esterno',path: '/trattamento-cotto-esterno',getParentRoute: () => rootRouteImport
          })
const TrattamentoMarmoPietreGranigliaRoute = TrattamentoMarmoPietreGranigliaRouteImport.update({
            id: '/trattamento-marmo-pietre-graniglia',path: '/trattamento-marmo-pietre-graniglia',getParentRoute: () => rootRouteImport
          })
const TrattamentoPavimentiCottoBergamoRoute = TrattamentoPavimentiCottoBergamoRouteImport.update({
            id: '/trattamento-pavimenti-cotto-bergamo',path: '/trattamento-pavimenti-cotto-bergamo',getParentRoute: () => rootRouteImport
          })
const TrattamentoPavimentiCottoBresciaRoute = TrattamentoPavimentiCottoBresciaRouteImport.update({
            id: '/trattamento-pavimenti-cotto-brescia',path: '/trattamento-pavimenti-cotto-brescia',getParentRoute: () => rootRouteImport
          })
const TrattamentoPavimentiCottoMilanoRoute = TrattamentoPavimentiCottoMilanoRouteImport.update({
            id: '/trattamento-pavimenti-cotto-milano',path: '/trattamento-pavimenti-cotto-milano',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ComePulireIlCottoRoute: ComePulireIlCottoRoute,ContattaciRoute: ContattaciRoute,PuliziaLavaggioCottoRoute: PuliziaLavaggioCottoRoute,PuliziaTrattamentoGresRoute: PuliziaTrattamentoGresRoute,ServiziRoute: ServiziRoute,TrattamentoCottoEsternoRoute: TrattamentoCottoEsternoRoute,TrattamentoMarmoPietreGranigliaRoute: TrattamentoMarmoPietreGranigliaRoute,TrattamentoPavimentiCottoBergamoRoute: TrattamentoPavimentiCottoBergamoRoute,TrattamentoPavimentiCottoBresciaRoute: TrattamentoPavimentiCottoBresciaRoute,TrattamentoPavimentiCottoMilanoRoute: TrattamentoPavimentiCottoMilanoRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)